var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-all-audit',{staticClass:"pt-all-audit__withData",attrs:{"departmentList":_vm.departmentList},on:{"exportMedicalRewardList":_vm.exportMedicalRewardList,"exportAllAudit":_vm.exportAllAudit}})}
var staticRenderFns = []

export { render, staticRenderFns }